// extracted by mini-css-extract-plugin
export default {"main":"Cookies_main__hCncV","title":"Cookies_title__3uJfl","description":"Cookies_description__mL+Jt","categoryHeader":"Cookies_categoryHeader__zC+e4"};